import api from './api';

// Session ID persists per browser tab
let sessionId = sessionStorage.getItem('analytics_session_id');
if (!sessionId) {
  sessionId = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem('analytics_session_id', sessionId);
}

const platform = window.innerWidth < 768 ? 'mobile' : 'desktop';

export const track = (eventName, metadata) => {
  api.post('/analytics/event', {
    event_name: eventName,
    page: window.location.pathname,
    session_id: sessionId,
    metadata: metadata || undefined,
  }).catch(() => {}); // fire-and-forget
};

export const trackSessionStart = () => {
  track('session_start', {
    platform,
    screen_width: window.innerWidth,
    user_agent: navigator.userAgent,
  });
};

export const trackPageView = (page) => {
  track('page_view', { page });
};

// Admin endpoints
export const getAnalyticsSummary = async (days = 30) => {
  const response = await api.get('/analytics/admin/summary', { params: { days } });
  return response.data;
};
